/** Aligns with inventory-api discount types. */
export enum DiscountType {
    value = 1,
    percentage = 2,
    price_override = 3,
}

export enum PromoType {
    Offer = 1,
    Discount = 2,
    Promo = 3,
}

export const LINE_DISCOUNT_TYPE_OPTIONS = [
    { value: DiscountType.value, name: 'Value' },
    { value: DiscountType.percentage, name: 'Percent' },
    { value: DiscountType.price_override, name: 'Price override' },
];

export const GLOBAL_HEADER_DISCOUNT_TYPE_OPTIONS = [
    { value: DiscountType.value, name: 'Value' },
    { value: DiscountType.percentage, name: 'Percent' },
];
